import { k as ensure_array_like, h as head, b as attr, e as escape_html, n as maybe_selected, c as attr_class, m as stringify, p as pop, a as push } from "../../../../chunks/index2.js";
import { p as page } from "../../../../chunks/index3.js";
import { g as goto } from "../../../../chunks/client2.js";
import { g as getCartState } from "../../../../chunks/Cart.svelte.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
import { P as ProductFilterSidebar } from "../../../../chunks/ProductFilterSidebar.js";
import { P as Pagination } from "../../../../chunks/Pagination.js";
function _page($$payload, $$props) {
  push();
  const { data } = $$props;
  const products = data.products || [];
  const categories = data.categories || [];
  const currentPage = data.page || 1;
  const totalPages = data.totalPages || 1;
  const totalResults = data.totalResults || 0;
  let selectedCategories = [];
  let selectedYear = "all";
  let itemsPerPage = "10";
  let searchQuery = "";
  let sortBy = "publication_desc";
  let isMobileFiltersOpen = false;
  getCartState();
  getToastState();
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const years = Array.from({ length: currentYear - 1960 + 1 }, (_, i) => currentYear - i);
  const itemsPerPageOptions = [
    { value: "10", label: "10 records" },
    { value: "20", label: "20 records" },
    { value: "50", label: "50 records" },
    { value: "100", label: "100 records" },
    { value: "1000", label: "1000 records" }
  ];
  function updateURL(categories2 = [], year = "all", page2 = 1, limit = "10", search = "", sort = "publication_desc") {
    const url = new URL(window.location.href);
    url.searchParams.set("categories", categories2.join(","));
    url.searchParams.set("year", year);
    url.searchParams.set("page", page2.toString());
    url.searchParams.set("limit", limit);
    url.searchParams.set("search", search);
    url.searchParams.set("sort", sort);
    return goto(url.toString(), {});
  }
  function handleCategoryToggle(categoryId) {
    let newSelectedCategories;
    if (selectedCategories.includes(categoryId)) {
      newSelectedCategories = selectedCategories.filter((id) => id !== categoryId);
    } else {
      newSelectedCategories = [...selectedCategories, categoryId];
    }
    updateURL(newSelectedCategories, selectedYear, 1, itemsPerPage, searchQuery, sortBy);
  }
  function handleYearChange(year) {
    updateURL(selectedCategories, year, 1, itemsPerPage, searchQuery, sortBy);
  }
  function handlePageChange(page2) {
    updateURL(selectedCategories, selectedYear, page2, itemsPerPage, searchQuery, sortBy);
  }
  function clearFilters() {
    updateURL([], "all", 1, "20", "", "publication_desc");
  }
  function toggleMobileFilters() {
    isMobileFiltersOpen = !isMobileFiltersOpen;
  }
  const buildProductHref = (productId) => `/product/${productId}?categories=${selectedCategories.join(",")}&year=${selectedYear}&page=${currentPage}&limit=${itemsPerPage}&search=${encodeURIComponent(searchQuery)}&sort=${sortBy}`;
  const each_array = ensure_array_like(itemsPerPageOptions);
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>Products</title>`;
  });
  $$payload.out.push(`<div class="container mx-auto px-4 py-8"><h1 class="mb-8 text-3xl font-bold">Product Catalogue</h1> <div class="flex gap-8">`);
  ProductFilterSidebar($$payload, {
    categories,
    selectedCategories,
    selectedYear,
    years,
    isMobileFiltersOpen,
    onCategoryToggle: handleCategoryToggle,
    onYearChange: handleYearChange,
    onClearFilters: clearFilters,
    onToggleMobileFilters: toggleMobileFilters
  });
  $$payload.out.push(`<!----> <main class="flex-1"><div class="mb-6"><form class="flex gap-2"><div class="relative flex-1"><input type="text" placeholder="Search products..."${attr("value", searchQuery)} class="focus:border-primary focus:ring-primary/30 w-full rounded-lg border border-gray-300 px-4 py-2 pl-10 focus:ring-5 focus:outline-hidden"/> <i class="bi bi-search absolute top-1/2 left-3 -translate-y-1/2 text-gray-400"></i></div> <button type="submit" class="bg-primary hover:bg-primary/90 rounded-lg px-6 py-2 text-white transition-colors">Search</button> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></form></div> <div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"><div class="flex items-center gap-4"><button class="rounded-lg bg-gray-100 p-2 lg:hidden" aria-label="Toggle filters"><i class="bi bi-funnel text-sm"></i></button> <span class="text-sm text-gray-600">${escape_html(totalResults)} results</span> `);
  if (selectedCategories.length > 0 || selectedYear !== "all" || page.url.searchParams.get("search")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<button class="text-primary hover:text-primary/80 text-sm underline">Clear All Filters</button>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4"><div class="flex items-center gap-2"><label for="items-per-page" class="text-sm whitespace-nowrap text-gray-600">Show:</label> <select id="items-per-page" class="focus:border-primary focus:ring-primary/30 min-w-[120px] rounded border border-gray-200 px-2 py-1 text-sm focus:ring-5 focus:outline-hidden">`);
  $$payload.select_value = itemsPerPage;
  $$payload.out.push(`<!--[-->`);
  for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
    let option = each_array[$$index];
    $$payload.out.push(`<option${attr("value", option.value)}${maybe_selected($$payload, option.value)}>${escape_html(option.label)}</option>`);
  }
  $$payload.out.push(`<!--]-->`);
  $$payload.select_value = void 0;
  $$payload.out.push(`</select></div> <div class="flex items-center gap-2"><label for="sort-by" class="text-sm whitespace-nowrap text-gray-600">Sort by:</label> <select id="sort-by" class="focus:border-primary focus:ring-primary/30 min-w-[140px] rounded border border-gray-200 px-2 py-1 text-sm focus:ring-5 focus:outline-hidden">`);
  $$payload.select_value = sortBy;
  $$payload.out.push(`<option value="publication_desc"${maybe_selected($$payload, "publication_desc")}>Publication Date</option><option value="newest"${maybe_selected($$payload, "newest")}>Newest First</option><option value="price_asc"${maybe_selected($$payload, "price_asc")}>Price: Low to High</option><option value="price_desc"${maybe_selected($$payload, "price_desc")}>Price: High to Low</option><option value="name_asc"${maybe_selected($$payload, "name_asc")}>Name: A to Z</option>`);
  $$payload.select_value = void 0;
  $$payload.out.push(`</select></div></div></div> <div class="grid grid-cols-2 gap-x-4 gap-y-8 sm:gap-x-5 sm:gap-y-7 xl:grid-cols-3">`);
  if (products.length === 0) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="col-span-full text-center text-gray-600">No products found</div>`);
  } else {
    $$payload.out.push("<!--[!-->");
    const each_array_1 = ensure_array_like(products);
    $$payload.out.push(`<!--[-->`);
    for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
      let product = each_array_1[$$index_1];
      $$payload.out.push(`<div class="group relative flex flex-col overflow-visible rounded-sm border bg-white px-3 py-2 transition-shadow hover:shadow-sm md:flex-row md:gap-3"><a${attr("href", buildProductHref(product.id))} class="block w-full shrink-0 md:relative md:w-24"><span class="block aspect-square w-full overflow-hidden rounded-sm bg-gray-50 ring-1 ring-gray-200 md:aspect-auto md:h-36 md:-translate-y-6"><img${attr("src", product.Image[0]?.url || "/coat-of-arms.jpg")}${attr("alt", product.name)} class="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"/></span></a> <div class="flex flex-1 flex-col pt-3 md:pt-0"><a${attr("href", buildProductHref(product.id))} class="block flex-1"><h3 class="line-clamp-2 pr-1 text-sm leading-snug font-semibold md:text-base">${escape_html(product.name)}</h3> <p class="mt-1 line-clamp-2 text-xs text-gray-600 md:line-clamp-2 md:text-[11px]">${escape_html(product.description)}</p></a> <div class="mt-auto flex items-center justify-between gap-2 pt-3"><span class="text-sm font-bold md:text-base">`);
      if (product.discountedPrice) {
        $$payload.out.push("<!--[-->");
        $$payload.out.push(`<span class="mr-1 text-sm text-gray-500 line-through">KES ${escape_html(product.price.toLocaleString())}</span> <span class="text-primary">KES ${escape_html(product.discountedPrice.toLocaleString())}</span>`);
      } else {
        $$payload.out.push("<!--[!-->");
        $$payload.out.push(`KES ${escape_html(product.price.toLocaleString())}`);
      }
      $$payload.out.push(`<!--]--></span> <button${attr_class(`rounded-md px-3 py-2 text-xs text-white transition-colors md:text-sm ${stringify(product.quantity > 0 ? "bg-primary hover:bg-primary/90" : "cursor-not-allowed bg-gray-400")}`)}>${escape_html(product.quantity > 0 ? "Add to Cart" : "Out of Stock")}</button></div></div></div>`);
    }
    $$payload.out.push(`<!--]-->`);
  }
  $$payload.out.push(`<!--]--></div> <div class="mt-8">`);
  Pagination($$payload, { currentPage, totalPages, onPageChange: handlePageChange });
  $$payload.out.push(`<!----></div></main></div></div>`);
  pop();
}
export {
  _page as default
};
